import React from 'react';
import { Snackbar, makeStyles } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
    root: {
        zIndex: '9999'
    }
}));

function CustomAlert({ openNotify, setOpenNotify, notificationMessage, messageType, verticalPosition = 'top',
horizontalPosition = 'right'}) {
    const classes = useStyles();
    const handleCloseNotification = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenNotify(false);
    };

    return (
        <>
            <Snackbar open={openNotify} autoHideDuration={3000} onClose={handleCloseNotification}
                anchorOrigin={{ vertical: verticalPosition, horizontal: horizontalPosition }} className={classes.root}>
                <Alert onClose={handleCloseNotification} severity={messageType}>
                    {notificationMessage}
                </Alert>
            </Snackbar>
        </>
    )
}

export default CustomAlert
